import { render } from "./app-tab.vue?vue&type=template&id=7cf978e0"
import script from "./app-tab.vue?vue&type=script&lang=js"
export * from "./app-tab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/tab/app-tab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7cf978e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7cf978e0', __exports__)) {
    console.log('reload')
    api.reload('7cf978e0', __exports__)
  }
  
  module.hot.accept("./app-tab.vue?vue&type=template&id=7cf978e0", () => {
    console.log('re-render')
    api.rerender('7cf978e0', render)
  })

}


export default __exports__